import React from "react";
import { ChevronRight, Home, FileText } from "lucide-react";
import { LucideIcon } from "./icon-registry";

export interface BreadcrumbPill {
    kind: "category" | "folder" | "home" | "page";
    label: string;
    iconName?: string | null;
    iconColor?: string | null;
    onClick?: () => void;
}

interface Props {
    pills: BreadcrumbPill[];
    right?: React.ReactNode;
}

export default function Breadcrumb({ pills, right }: Props) {
    return (
        <div className="m-breadcrumb-row">
            <div className="m-breadcrumb-pills">
                {pills.map((p, i) => {
                    const isLast = i === pills.length - 1;
                    return (
                        <React.Fragment key={i}>
                            {i > 0 && <ChevronRight size={14} className="m-breadcrumb-sep" />}
                            <Pill pill={p} active={isLast} />
                        </React.Fragment>
                    );
                })}
            </div>
            {right && <div className="m-breadcrumb-right">{right}</div>}
        </div>
    );
}

function Pill({ pill, active }: { pill: BreadcrumbPill; active: boolean }) {
    const defaultBg =
        pill.kind === "category" ? "#3B82F6"
            : pill.kind === "home" ? "#0f172a"
                : pill.kind === "page" ? "#1e85e5"
                    : "#64748b";
    const bg = pill.iconColor || defaultBg;
    const content = (
        <>
            <span className="m-breadcrumb-pill-icon" style={{ background: bg }}>
                {pill.kind === "category" && <LucideIcon name={pill.iconName || "FolderClosed"} size={12} color="#fff" />}
                {pill.kind === "folder" && <LucideIcon name={pill.iconName || "FolderClosed"} size={12} color="#fff" />}
                {pill.kind === "home" && <Home size={12} color="#fff" />}
                {pill.kind === "page" && <FileText size={12} color="#fff" />}
            </span>
            <span className="m-breadcrumb-pill-label">{pill.label}</span>
        </>
    );
    const className = `m-breadcrumb-pill${active ? " active" : ""}`;
    if (pill.onClick && !active) {
        return (
            <button type="button" className={className} onClick={pill.onClick}>
                {content}
            </button>
        );
    }
    return <span className={className}>{content}</span>;
}
